import { getRoute } from "@utils/route";

export const THANK_YOU_PAGE_URL = '/thank-you';

export const routeThankYouPage = () => getRoute(THANK_YOU_PAGE_URL);
